import React, { forwardRef, memo, useContext } from 'react';
import { ModalContext } from './contexts';
import { Typography } from '../typography';
export const Title = memo(forwardRef(function Title({ renderTitle, ...props }, ref) {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('Title component has to be placed inside Modal.Overlay');
    }
    const { titleProps } = context;
    if (renderTitle) {
        return renderTitle(titleProps, props);
    }
    return React.createElement(Typography, { ...titleProps, color: props.color || 'main', ...props, ref: ref });
}));
